module.exports = {
    logout: "Logout",
    logout_mini: "L"
  }